(function () {
	/**
	 * Global hash deeplinks
	 *
	 * @author Matthias Inauen
	 * @namespace SCS
	 * @class HashDeepLink
	 */

	'use strict';
	window.SCS = window.SCS || {};

	window.SCS.HashDeepLink = require('lib/util/url').hashDeepLink;

}());



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/libraries/SCS.hashdeeplink.js
// module id = 325
// module chunks = 0